import dashboard from "@/navigation/vertical/swissnews/dashboard";
import administration from "@/navigation/vertical/swissnews/administration";
import layout from "@/navigation/vertical/swissnews/layout";

export default [
    ...dashboard,
    ...layout,
    ...administration
]
